import { Group, UpIcon, XIcon, move } from "../fields";
import { uniqueId } from "../model";

type Option = { id: string; label: string };

/** Rows of options. Ids stay put when labels change, so live votes keep pointing at the right option. */
export function OptionsEditor({
  value,
  onChange,
  min = 2,
  max = 6,
}: {
  value: Option[];
  onChange: (v: Option[]) => void;
  min?: number;
  max?: number;
}) {
  return (
    <Group title={`Options (${value.length}/${max})`}>
      {value.map((o, i) => (
        <div key={o.id} className="row-gap" style={{ flexWrap: "nowrap" }}>
          <span className="group-id" style={{ width: 20 }}>
            {String.fromCharCode(65 + i)}
          </span>
          <input
            className="input"
            aria-label={`Option ${i + 1}`}
            value={o.label}
            maxLength={80}
            onChange={(e) => onChange(value.map((x, j) => (j === i ? { ...x, label: e.target.value } : x)))}
          />
          <button
            type="button"
            className="icon-btn"
            aria-label="Move up"
            disabled={i === 0}
            onClick={() => onChange(move(value, i, i - 1))}
          >
            <UpIcon />
          </button>
          <button
            type="button"
            className="icon-btn"
            aria-label="Move down"
            disabled={i === value.length - 1}
            onClick={() => onChange(move(value, i, i + 1))}
          >
            <UpIcon down />
          </button>
          <button
            type="button"
            className="icon-btn"
            aria-label="Remove option"
            disabled={value.length <= min}
            onClick={() => onChange(value.filter((_, j) => j !== i))}
          >
            <XIcon />
          </button>
        </div>
      ))}
      {value.length < max && (
        <button
          type="button"
          className="s-btn-dashed s-btn"
          style={{ alignSelf: "flex-start" }}
          onClick={() =>
            onChange([
              ...value,
              {
                id: uniqueId(
                  String.fromCharCode(97 + value.length),
                  value.map((o) => o.id),
                ),
                label: "",
              },
            ])
          }
        >
          + Option
        </button>
      )}
    </Group>
  );
}
